<template>
  <div class="box">
    <div class="box-header with-border">
      <h3 class="box-title">Automatic additional data</h3>
    </div>
    <!-- /.box-header -->
    <div class="box-body">

      <weather-card v-if="testimonyLocation" :longitude="testimonyLocation.longitude" :latitude="testimonyLocation.latitude"
                    :testimonyTime="testimonyTime"/>
      
      <tweet v-for="tweet in tweets" :key="tweet.id" :id="tweet.id" :options="{ cards: 'hidden' }"></tweet>
      
      <!-- /.box-body -->
    </div>
  </div>
</template>

<script>
  // import api from '../../api'

  export default {
    name: 'AutomaticData',
    props: ['testimonyLocation', 'testimonyTime'],
    data () {
      return {
        tweets: []
      }
    },
    methods: {
      getTweets () {
        this.tweets = [{ id: '955173521138823169' }, { id: '955031868373549056' }, { id: '954244683630284801' }, { id: '953030868360196096' }]
        /* api.authenticatedRequest('get', `/testimonies/${this.id}/history`)
          .then(response => {
            this.history = response.data.data.map((testimony) => {
              return testimony.document
            })
            this.history.unshift(JSON.parse(JSON.stringify(this.testimony)))
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          }) */
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.getTweets()
      })
    }
  }
  
</script>



// WEBPACK FOOTER //
// AutomaticData.vue?78459154